module.exports = __webpack_public_path__ + "media/dashboard/assets/images/doc-9331bf9caa0662547c7304ede3ad2a8c.png";